// extracted by mini-css-extract-plugin
export default {"tooltip":"YP-z","arrow":"ZP-z"};